import type { SVGProps } from "react";
const SvgHotel02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 7v11c0 1.886 0 2.828.586 3.414S5.114 22 7 22h10c1.886 0 2.828 0 3.414-.586S21 19.886 21 18V7M17 7A5 5 0 0 0 7 7"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 22v-4a2 2 0 1 0-4 0v4M9 3H4.472c-.31 0-.625.082-.874.329C2.856 4.064 2.428 5.288 2 7h5m8-4h4.528c.31 0 .625.082.874.329.742.735 1.17 1.959 1.598 3.671h-5M6 11h.5M6 14.5h.5M17.5 11h.5m-.5 3.5h.5M10.5 8v1.5m0 1.5V9.5m3-1.5v1.5m0 1.5V9.5m-3 0h3"
    />
  </svg>
);
export default SvgHotel02;
